import { Avatar, Box, Button, Modal, Rating } from '@mui/material'
import React, { useState } from 'react'
import PostReviewUserImage from '../assets/imgs/post-review-user-image.png'
import StarsRating from '../assets/imgs/stars-rating.png'
import PlusIcon from '../assets/imgs/plus-icon.svg'
import UserImagePlaceholder from '../assets/imgs/user-image-placeholder.png'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  padding: '20px 40px',
  borderRadius: '16px',
  textAlign: 'center',
}

const PostaReviewModal = ({
  handlePostaReviewModal,
  togglePostaReviewModal,
  userType,
  booking,
  body,
  getClientsReviews,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [review, setReview] = useState({
    rating: 0,
    message: '',
    image: null,
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    setReview({ ...review, [e.target.name]: e.target.value })
  }

  const submitReview = async () => {
    if (review.message !== '' && review.rating !== 0) {
      let req = {
        ...body,
        rating: Number(review?.rating),
        comment: review?.message,
        image: review?.image,
      }
      // if (booking) {
      //   body.user_id = user?.id
      //   body.stylist_id = booking?.stylist?.id
      //   body.service_id = booking?.service?.id
      // }
      let formData = new FormData()
      formData.append('user_id', user?.id)
      formData.append('stylist_id', req.stylist_id)
      formData.append('service_id', req.service_id)
      formData.append('image', review?.image)
      formData.append('comment', review?.message)
      formData.append('rating', Number(review?.rating))
      let result
      if (userType === 'client') {
        setIsLoading(true)
        result = await saveOrUpdateDataById('user-post-review', formData)
        setIsLoading(false)
      } else if (userType === 'provider') {
        setIsLoading(true)
        result = await saveOrUpdateDataById('stylist-post-review', formData)
        setIsLoading(false)
      }
      if (result?.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Review posted successfully!',
          timer: 3000,
          confirmButtonColor: '#2597F6',
        })
        handlePostaReviewModal(false)
        getClientsReviews()
      }
    }
  }

  const handleReviewImageUpload = (e) => {
    setReview((prev) => ({ ...prev, image: e.target.files[0] }))
  }

  return (
    <div className="text-center">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={togglePostaReviewModal}
        onClose={() => handlePostaReviewModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div>
            <h3 className="fw-bold fs-24">Post a review</h3>
            {user?.profile_image && (
              <Avatar
                src={user?.profile_image}
                sx={{ height: 100, width: 100, margin: 'auto' }}
              />
            )}
            {!user?.profile_image && (
              <Avatar
                src={UserImagePlaceholder}
                sx={{ height: 100, width: 100, margin: 'auto' }}
              />
            )}
            {/* <img
              src={user?.profile_image}
              alt="Post Review User Image"
              height={100}
              width={100}
              className="my-2"
              style={{ borderRadius: '50%' }}
            /> */}
            <p className="fs-20 font-weight-bold mt-2">John D.</p>
            <p className="fs-16">Hair Stylist</p>
            <p className="fs-16 font-weight-bold mt-3 mb-2">
              Rate Your Experience
            </p>
            <Rating
              name="rating"
              value={review.rating || 0}
              onChange={handleChange}
            />
            <div className="mt-3 bordered-text p-3 text-center">
              <textarea
                className="customer-support-message"
                name="message"
                placeholder="Write a message"
                cols="40"
                rows="7"
                value={review.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <label
              className="add-a-picture mt-3 py-2 position-relative pointer w-100"
              htmlFor="review-picture"
            >
              <input
                type="file"
                accept="image/*"
                className="position-absolute d-none"
                id="review-picture"
                onChange={handleReviewImageUpload}
              />
              <p className="fs-16 color-primary d-flex justify-content-center align-items-center gap-1">
                {' '}
                <img src={PlusIcon} alt="Plus Icon" height={11} /> Add Picture
              </p>
            </label>
            <Button
              id="btn-primary-no-shadow"
              className="pointer mt-5"
              disableElevation
              fullWidth
              onClick={submitReview}
            >
              Share Review
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default PostaReviewModal
